/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Honor_1_Item_2_TitleInputs */

const en_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf Digest #1 instructor living in Iowa`)
};

const es_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructor n.º 1 residente en Iowa según Golf Digest`)
};

const de_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf Digest: Golflehrer Nr. 1 mit Wohnsitz in Iowa`)
};

const zh_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf Digest 评选的居住在爱荷华州的 #1 教练`)
};

const ar_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المدرب رقم 1 المقيم في Iowa حسب Golf Digest`)
};

const fr_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructeur n° 1 vivant dans l’Iowa selon Golf Digest`)
};

const vi_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huấn luyện viên số 1 sống tại Iowa theo Golf Digest`)
};

const sw_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mkufunzi #1 anayeishi Iowa kwa mujibu wa Golf Digest`)
};

const th_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้ฝึกสอนอันดับ 1 ที่อาศัยอยู่ในไอโอวาจาก Golf Digest`)
};

const bs_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruktor broj 1 koji živi u Iowi prema Golf Digestu`)
};

const ja_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf Digest選出 アイオワ州在住No.1インストラクター`)
};

const ko_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf Digest 선정 Iowa 거주 #1 강사`)
};

const pt_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instrutor nº 1 residente em Iowa segundo a Golf Digest`)
};

const it_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Istruttore n. 1 in Iowa secondo Golf Digest`)
};

const sv_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf Digest: #1 instruktör bosatt i Iowa`)
};

const nl_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volgens Golf Digest de nr. 1 golfleraar in Iowa`)
};

const da_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf Digest: #1 instruktør bosat i Iowa`)
};

const nb_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf Digest: #1 instruktør bosatt i Iowa`)
};

const fi_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowassa asuva #1 golfopettaja Golf Digestin mukaan`)
};

const pl_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruktor nr 1 mieszkający w Iowa według Golf Digest`)
};

const ru_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инструктор №1, живущий в Iowa, по версии Golf Digest`)
};

const tr_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf Digest'e göre Iowa'da yaşayan 1 numaralı eğitmen`)
};

const hi_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf Digest के अनुसार Iowa में रहने वाले #1 प्रशिक्षक`)
};

const id_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruktur nomor 1 di Iowa versi Golf Digest`)
};

const ms_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jurulatih #1 yang menetap di Iowa versi Golf Digest`)
};

const cs_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf Digest: #1 instruktor žijící v Iowě`)
};

const el_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#1 εκπαιδευτής που ζει στην Iowa κατά το Golf Digest`)
};

const he_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`המדריך #1 המתגורר ב-Iowa לפי Golf Digest`)
};

const af_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf Digest se #1 instrukteur woonagtig in Iowa`)
};

const hu_about_content_honor_1_item_2_title = /** @type {(inputs: About_Content_Honor_1_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Golf Digest szerint a #1 Iowában élő oktató`)
};

/**
* | output |
* | --- |
* | "Golf Digest #1 instructor living in Iowa" |
*
* @param {About_Content_Honor_1_Item_2_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_honor_1_item_2_title = /** @type {((inputs?: About_Content_Honor_1_Item_2_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Honor_1_Item_2_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_honor_1_item_2_title(inputs)
	if (locale === "de") return de_about_content_honor_1_item_2_title(inputs)
	if (locale === "zh") return zh_about_content_honor_1_item_2_title(inputs)
	if (locale === "ar") return ar_about_content_honor_1_item_2_title(inputs)
	if (locale === "fr") return fr_about_content_honor_1_item_2_title(inputs)
	if (locale === "vi") return vi_about_content_honor_1_item_2_title(inputs)
	if (locale === "sw") return sw_about_content_honor_1_item_2_title(inputs)
	if (locale === "th") return th_about_content_honor_1_item_2_title(inputs)
	if (locale === "bs") return bs_about_content_honor_1_item_2_title(inputs)
	if (locale === "ja") return ja_about_content_honor_1_item_2_title(inputs)
	if (locale === "ko") return ko_about_content_honor_1_item_2_title(inputs)
	if (locale === "pt") return pt_about_content_honor_1_item_2_title(inputs)
	if (locale === "it") return it_about_content_honor_1_item_2_title(inputs)
	if (locale === "sv") return sv_about_content_honor_1_item_2_title(inputs)
	if (locale === "nl") return nl_about_content_honor_1_item_2_title(inputs)
	if (locale === "da") return da_about_content_honor_1_item_2_title(inputs)
	if (locale === "nb") return nb_about_content_honor_1_item_2_title(inputs)
	if (locale === "fi") return fi_about_content_honor_1_item_2_title(inputs)
	if (locale === "pl") return pl_about_content_honor_1_item_2_title(inputs)
	if (locale === "ru") return ru_about_content_honor_1_item_2_title(inputs)
	if (locale === "tr") return tr_about_content_honor_1_item_2_title(inputs)
	if (locale === "hi") return hi_about_content_honor_1_item_2_title(inputs)
	if (locale === "id") return id_about_content_honor_1_item_2_title(inputs)
	if (locale === "ms") return ms_about_content_honor_1_item_2_title(inputs)
	if (locale === "cs") return cs_about_content_honor_1_item_2_title(inputs)
	if (locale === "el") return el_about_content_honor_1_item_2_title(inputs)
	if (locale === "he") return he_about_content_honor_1_item_2_title(inputs)
	if (locale === "af") return af_about_content_honor_1_item_2_title(inputs)
	if (locale === "hu") return hu_about_content_honor_1_item_2_title(inputs)
	return en_about_content_honor_1_item_2_title(inputs)
});